"use client";

import { useEffect } from "react";
import { notification } from "antd";
import {useTranslation} from "react-i18next";

export default function NotificationHandler({ verified }) {
    const [api, contextHolder] = notification.useNotification();
    const {t} = useTranslation();

    useEffect(() => {
        if (verified === "true") {
            api.success({
                message: t('notifications.success'),
                description: t('notifications.contactVerified'),
                placement: 'bottomRight',
            });

            const url = new URL(window.location.href);
            url.searchParams.delete("verified");
            window.history.replaceState({}, "", url.toString());
        }
    }, [verified]);

    return <>{contextHolder}</>;
}